export const programTemplateFormFields = [
  'cover_photo',
  'description',
  'invitation_email',
  'labels',
  'name',
  'phases',
  'program_type',
];
